// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import DoubleRightOutlinedSvg from "@ant-design/icons-svg/lib/asn/DoubleRightOutlined";
import AntdIcon from "../components/AntdIcon";
const DoubleRightOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: DoubleRightOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    DoubleRightOutlined.displayName = "DoubleRightOutlined";
}
export default /*#__PURE__*/ React.forwardRef(DoubleRightOutlined);
